import { json, type ActionFunctionArgs } from '@remix-run/node';
import { z } from 'zod';
import { updateConversationParticipants } from '~/modules/chat/api/update-conversation-participants.server';

export const REMOVE_PARTICIPANT_API = '/remix-api/chat/remove-participant';

const FORM_DATA_SCHEMA = z.object({
    conversationID: z.coerce.number().int().positive(),
    professionalID: z.coerce.number().int().positive().nullish(),
    participantID: z.coerce.number().int().positive(),
});

/**
 * API endpoint to remove a participant from a conversation. Use with the `useUpdateConversation` hook.
 * @see {@link packages/web/app/modules/chat/hooks/use-update-conversation.ts}
 */
export const action = async ({ context, request }: ActionFunctionArgs) => {
    const { logger } = context;
    const payload = await request.json();
    const result = FORM_DATA_SCHEMA.safeParse(payload);

    if (!result.success) {
        return json(null, { status: 400 });
    }

    try {
        const response = await updateConversationParticipants({
            context,
            conversationID: result.data.conversationID,
            professionalID: result.data.professionalID,
            removeParticipantIDs: [result.data.participantID],
        });

        if (!response) {
            return json(null, { status: 500 });
        }

        return json({
            conversation: response.conversation,
            systemMessages: response.systemMessages,
        });
    } catch (error) {
        logger.error(`Error in ${REMOVE_PARTICIPANT_API}`, {
            error,
            data: result.data,
        });
        return json(null, { status: 500 });
    }
};
